import "./WhatsAppButton.scss";
import { useDispatch, useSelector } from "react-redux";
import { SUPPORT } from "../../utils/constants";
function WhatsAppButton(props) {
  const token = useSelector((state) => state.session.token);
  return (
    <div>
      <div id="whatsapp-link-div">
        <a
          className={`whatsapp-link1 ${!token ? "whatsappLoggedClass" : ""}`}
          href={SUPPORT.whatsappUrl}
          target="_blank"
          rel="noreferrer"
        >
          <i className="fa-brands fa-whatsapp"></i>
        </a>
      </div>
    </div>
  );
}

export default WhatsAppButton;
